'use client'

import { useTallyFormSubmit } from '@/hooks/use-tally-form-submit'
import Script from 'next/script'

export const TallyForm = () => {
  useTallyFormSubmit()

  return (
    <>
      {/* Tally Form Embed */}
      <iframe
        data-tally-src="https://tally.so/embed/lbyVp6?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
        loading="lazy"
        width="100%"
        frameBorder="0"
        marginHeight={0}
        marginWidth={0}
        title="お問い合わせ・資料請求"
      />

      {/* Tally Widget Script */}
      <Script src="https://tally.so/widgets/embed.js" strategy="lazyOnload" />
    </>
  )
}
